import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import alertGiftPng from '@/assets/landing/alert-gift.png'
import walking40Webp from '@/assets/landing-activity-female/walking-40.webp'
import walking50Webp from '@/assets/landing-activity-female/walking-50.webp'
import walking60Webp from '@/assets/landing-activity-female/walking-60.webp'
import walking70Webp from '@/assets/landing-activity-female/walking-70.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingAlert', 'LandingTitleExtended', 'LandingAgeGrid'],

	components: {
		LandingTitleExtended: ({ $t }): LandingComponentsConfig['LandingTitleExtended'] => ({
			title: $t('female_walking.pages.landing.step_1.title'),
			note: $t('female_yoga.pages.landing.quiz'),
		}),

		LandingAlert: ({ $t }): LandingComponentsConfig['LandingAlert'] => ({
			text: $t('female_yoga.pages.landing.alert_text'),
			icon: alertGiftPng,
			backgroundColor: 'var(--Fill-Accent-16)',
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: walking40Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: walking50Webp,
				},
				{
					value: 60,
					analyticValue: '60-69',
					label: $t('female_yoga.pages.landing.age_range.60_69'),
					img: walking60Webp,
				},
				{
					value: 70,
					analyticValue: '70+',
					label: $t('female_yoga.pages.landing.age_range.70_80'),
					img: walking70Webp,
				},
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
